"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = __importDefault(require("../providers/api"));
var constants_1 = require("../constants");
exports.default = (function (deps) {
    var defaultApiProvider = new api_1.default();
    var defaultAuthProvider = {
        refreshToken: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    console.info('Requesting refreshToken message to parent');
                    deps.iframeHandler.postMessage('refreshToken');
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            var callback = function (event) {
                                if (event.data.startsWith('setRefreshToken')) {
                                    var data = JSON.parse(event.data.split('||')[1]);
                                    if (data) {
                                        defaultAuthProvider.setSession(data);
                                        deps.eventHandler.removeEvent('message', callback);
                                        return resolve(data);
                                    }
                                    return reject();
                                }
                            };
                            deps.eventHandler.addEvent('message', callback);
                        })];
                });
            });
        },
        doLogout: function () {
            console.info('Requesting logout');
            deps.iframeHandler.postMessage('logout');
            localStorage.removeItem(constants_1.SESSION_KEY);
        },
        doLogin: function () {
            console.log('Requesting login');
            deps.iframeHandler.postMessage('login');
        },
        setSession: function (session, emitEvent) {
            if (emitEvent === void 0) { emitEvent = true; }
            localStorage.setItem(constants_1.SESSION_KEY, JSON.stringify(session));
            if (this.changeState && emitEvent) {
                this.changeState(session);
            }
            return Promise.resolve(session);
        },
        getSession: function () {
            var session = JSON.parse(localStorage.getItem(constants_1.SESSION_KEY) || 'null');
            if (session) {
                var expires = parseInt(session.expires, 10);
                if (!isNaN(expires) && Date.now() >= session.expires) {
                    this.doLogout();
                    return null;
                }
            }
            return session;
        },
        getPermissions: function () {
            return ((this.getSession() || {})
                .currentUser || {})
                .permissions || [];
        }
    };
    defaultApiProvider.authProvider = defaultAuthProvider;
    return {
        defaultApiProvider: defaultApiProvider,
        defaultAuthProvider: defaultAuthProvider,
    };
});
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ../@core/dist/common/webApiHandler.js
// module id = 875
// module chunks = 0